/* Theme-owned tags. GTM v6 separates analytics and advertising consent per tag. */
(() => {
 'use strict';
 window.dataLayer = window.dataLayer || [];
 const consent = values => window.dataLayer.push((function(){return arguments;})('consent', 'update', values));
 const denied = {analytics_storage:'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'};
 window.dataLayer.push((function(){return arguments;})('consent','default',denied));
 let googleLoaded=false,clarityLoaded=false;
 function allowed(kind) {
  const p=window.Shopify?.customerPrivacy;
  try { const c=p?.currentVisitorConsent();return kind==='analytics' ? c?.analytics==='yes' && p.analyticsProcessingAllowed() : c?.marketing==='yes' && p.marketingAllowed(); } catch{return false;}
 }
 window.kkAuditConsentAllowed=allowed;
 function update() {
  const analytics=allowed('analytics'),marketing=allowed('marketing');
  consent({analytics_storage:analytics?'granted':'denied',ad_storage:marketing?'granted':'denied',ad_user_data:marketing?'granted':'denied',ad_personalization:marketing?'granted':'denied'});
  // Never contaminate production analytics from an unpublished theme or theme editor.
  const published=window.Shopify?.theme?.role==='main' && !window.Shopify?.designMode;
  // GA4 requires analytics consent; advertising-related tags also require ad_storage in GTM.
  if(published && analytics && !googleLoaded){
   googleLoaded=true;
   if(!document.querySelector('script[src*="googletagmanager.com/gtm.js?id=GTM-T6N6H5M5"]')){
    window.dataLayer.push({'gtm.start':Date.now(),event:'gtm.js'});
    const s=document.createElement('script');s.async=true;s.src='https://www.googletagmanager.com/gtm.js?id=GTM-T6N6H5M5';document.head.append(s);
   }
  }
  if(published && analytics && !clarityLoaded){
   clarityLoaded=true;
   window.clarity=window.clarity||function(){(window.clarity.q=window.clarity.q||[]).push(arguments);};
   window.clarity('consentv2',{ad_Storage:marketing?'granted':'denied',analytics_Storage:'granted'});
   if(!document.querySelector('script[src*="clarity.ms/tag/uq4592xf4v"]')){const s=document.createElement('script');s.async=true;s.src='https://www.clarity.ms/tag/uq4592xf4v';document.head.append(s);}
  }
  if(window.clarity)window.clarity('consentv2',{ad_Storage:marketing?'granted':'denied',analytics_Storage:analytics?'granted':'denied'});
  if(!analytics){try{sessionStorage.removeItem('kk_contact_pending');}catch{}}
  document.dispatchEvent(new CustomEvent('kk:consent-updated'));
 }
 document.addEventListener('visitorConsentCollected',update);
 function init(){
  if(window.Shopify?.customerPrivacy){update();return;}
  if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)update();});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
